<template>
  <div class="basic-setting-content pl16 pr16">
    <!--价格政策-->
    <div class="common-form">价格政策</div>

    <el-form-item label="计算方式：" :rules="[{ required: true, message: '请选择计算方式' }]">
      <el-radio-group v-model="form.model.sku.stageType">
        <el-radio :label="10" v-if="!form.isSpecLocked||(form.isSpecLocked&&form.model.sku.stageType==10)">固定价格</el-radio>
        <el-radio :label="20" v-if="!form.isSpecLocked||(form.isSpecLocked&&form.model.sku.stageType==20)">阶梯价格</el-radio>
      </el-radio-group>
      <div v-if="form.isSpecLocked" class="red">此设备正在参加活动，不能修改规格</div>
    </el-form-item>

    <!--固定价格-->
    <template v-if="form.model.sku.stageType == 10">
      <Fixed></Fixed>
    </template>

    <!--阶梯价格-->
    <template v-if="form.model.sku.stageType == 20">
      <Stage></Stage>
    </template>

  </div>
</template>

<script>
import Fixed from './priceStage/Fixed.vue';
import Stage from './priceStage/Stage.vue';

export default {
  components: {
    /*固定价格*/
    Fixed,
    /*阶梯价格*/
    Stage
  },
  inject: ['form']
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/product/product/part/PriceStage.vue